(function(){
  var cfgEl = document.getElementById('reno-progress-bar-config');
  if (!cfgEl || cfgEl.dataset.enabled !== 'true') return;

  var CFG = {
    thresholdCents: parseInt(cfgEl.dataset.thresholdCents, 10) || 200000,
    lockedText: cfgEl.dataset.lockedText || '{remaining} away from your free reward.',
    unlockedText: cfgEl.dataset.unlockedText || "You've unlocked your free reward! Choose one:",
    tabLabel: cfgEl.dataset.tabLabel || 'Reno Special',
    tabLabelUnlocked: cfgEl.dataset.tabLabelUnlocked || 'Free gift unlocked!',
    position: cfgEl.dataset.tabPosition === 'left' ? 'left' : 'right',
    openDefault: cfgEl.dataset.tabOpenDefault === 'true',
    barBg: cfgEl.dataset.barBg || '#0f2a26',
    barText: cfgEl.dataset.barTextColor || '#ffffff',
    fillColor: cfgEl.dataset.fillColor || '#007B6E',
    buttonColor: cfgEl.dataset.buttonColor || '#007B6E',
    showOnlyWithItems: cfgEl.dataset.showOnlyWithCartItems !== 'false',
    gateEnabled: cfgEl.dataset.gateEnabled === 'true',
    gatePrefix: cfgEl.dataset.gatePathPrefix || '/collections/reno-free-pick',
    gateText: cfgEl.dataset.gateText || 'This collection unlocks once your cart reaches the threshold. You are {remaining} away.',
    gateButtonLabel: cfgEl.dataset.gateButtonLabel || 'View my cart',
    gateButtonUrl: cfgEl.dataset.gateButtonUrl || '/cart',
    pick1Label: cfgEl.dataset.pick1Label || '20 Free Downlights',
    pick1Url: cfgEl.dataset.pick1Url || '/products/down-light-1199-white-tri-color?variant=45179425521717',
    pick1Note: cfgEl.dataset.pick1Note || "Add 20 to your cart \u2014 they'll turn free automatically, no code needed",
    pick2Label: cfgEl.dataset.pick2Label || 'Any Single Item up to $240',
    pick2Url: cfgEl.dataset.pick2Url || '/collections/reno-free-pick',
    pick2Code: cfgEl.dataset.pick2Code || 'RENOPICK',
    links: (function(){ try { return JSON.parse(cfgEl.dataset.links || '[]').filter(function(l){ return l.label && l.url; }); } catch(e){ return []; } })()
  };

  var POLL_MS = 4000;
  var forceOpenNext = false;

  function formatMoney(cents){
    return '$' + (cents/100).toFixed(2).replace(/\.00$/, '');
  }

  function fillTemplate(str, remaining){
    return str.replace('{remaining}', formatMoney(remaining));
  }

  function getCart(cb){
    fetch('/cart.js', {credentials:'same-origin'})
      .then(function(r){ return r.json(); })
      .then(cb)
      .catch(function(){});
  }

  function closeWidget(widget){
    widget.classList.remove('reno-open');
    sessionStorage.setItem('renoTabOpen', '0');
  }

  function buildWidget(){
    if (document.getElementById('reno-tab-widget')) return document.getElementById('reno-tab-widget');

    var style = document.createElement('style');
    style.textContent = [
      '#reno-backdrop{position:fixed;inset:0;background:rgba(0,0,0,.35);z-index:9997;display:none;}',
      '#reno-backdrop.reno-visible{display:block;}',
      '#reno-tab-widget{position:fixed;top:50%;' + CFG.position + ':0;transform:translateY(-50%);z-index:9998;display:flex;align-items:center;font-family:inherit;}',
      '#reno-tab-widget .reno-panel{order:' + (CFG.position === 'right' ? 2 : 1) + ';}',
      '#reno-tab-widget .reno-tab{order:' + (CFG.position === 'right' ? 1 : 2) + ';}',
      '#reno-tab-widget .reno-tab{writing-mode:vertical-rl;text-orientation:mixed;background:' + CFG.buttonColor + ';color:' + CFG.barText + ';border:none;cursor:pointer;padding:16px 8px;font-size:12px;font-weight:700;letter-spacing:.03em;border-radius:' + (CFG.position === 'right' ? '8px 0 0 8px' : '0 8px 8px 0') + ';box-shadow:0 2px 10px rgba(0,0,0,.2);white-space:nowrap;transition:transform .25s ease, box-shadow .25s ease;}',
      CFG.position === 'right' ? '#reno-tab-widget .reno-tab{transform:rotate(180deg);}' : '',
      '#reno-tab-widget .reno-panel{width:300px;max-width:80vw;background:' + CFG.barBg + ';color:' + CFG.barText + ';padding:18px;box-shadow:0 4px 20px rgba(0,0,0,.25);border-radius:' + (CFG.position === 'right' ? '8px 0 0 8px' : '0 8px 8px 0') + ';max-height:75vh;overflow-y:auto;transition:transform .3s ease, opacity .3s ease;transform:translateX(' + (CFG.position === 'right' ? '20px' : '-20px') + ');opacity:0;pointer-events:none;position:absolute;' + CFG.position + ':100%;top:50%;margin-top:-50%;}',
      '#reno-tab-widget.reno-open .reno-panel{transform:translateX(0) !important;opacity:1;pointer-events:auto;}',
      '#reno-tab-widget .reno-panel-head{display:flex;align-items:flex-start;justify-content:space-between;gap:8px;margin-bottom:6px;}',
      '#reno-tab-widget .reno-close{background:rgba(255,255,255,.12);border:none;color:' + CFG.barText + ';width:26px;height:26px;min-width:26px;border-radius:50%;cursor:pointer;font-size:16px;line-height:1;display:flex;align-items:center;justify-content:center;padding:0;}',
      '#reno-tab-widget .reno-track{height:8px;background:rgba(255,255,255,.2);border-radius:99px;overflow:hidden;margin-bottom:10px;}',
      '#reno-tab-widget .reno-fill{height:100%;background:' + CFG.fillColor + ';width:0%;transition:width .4s ease;}',
      '#reno-tab-widget .reno-text{font-size:13px;line-height:1.4;margin-bottom:12px;}',
      '#reno-tab-widget .reno-picks{display:none;flex-direction:column;gap:10px;}',
      '#reno-tab-widget.reno-unlocked .reno-picks{display:flex;}',
      '#reno-tab-widget .reno-pick{display:block;background:rgba(255,255,255,.08);border:1px solid rgba(255,255,255,.2);border-radius:8px;padding:10px 12px;text-decoration:none;color:' + CFG.barText + ';}',
      '#reno-tab-widget .reno-pick:hover{background:rgba(255,255,255,.15);}',
      '#reno-tab-widget .reno-pick-title{font-weight:700;font-size:13px;display:block;margin-bottom:2px;}',
      '#reno-tab-widget .reno-pick-code{font-size:11px;opacity:.75;display:block;}',
      '#reno-tab-widget .reno-cats-label{font-size:11px;opacity:.7;margin:10px 0 6px;}',
      '#reno-tab-widget .reno-cats{display:flex;gap:6px;flex-wrap:wrap;}',
      '#reno-tab-widget .reno-cats a{background:' + CFG.buttonColor + ';color:' + CFG.barText + ';padding:6px 10px;border-radius:6px;text-decoration:none;font-size:11px;font-weight:600;}',
      '@keyframes renoPulse{0%{transform:scale(1);}30%{transform:scale(1.07);}60%{transform:scale(0.99);}100%{transform:scale(1);}}',
      '#reno-tab-widget.reno-pulse .reno-tab{animation:renoPulse .6s ease;box-shadow:0 0 0 6px rgba(255,255,255,.25), 0 2px 10px rgba(0,0,0,.2);}',
      '#reno-tab-widget.reno-pulse .reno-panel{animation:renoPulse .6s ease;}',
      '@media (max-width:600px){',
      '  #reno-tab-widget{top:auto;bottom:96px;' + CFG.position + ':14px;transform:none;}',
      '  #reno-tab-widget .reno-tab{writing-mode:horizontal-tb;transform:none;border-radius:50%;width:52px;height:52px;padding:0;font-size:9px;line-height:1.1;display:flex;align-items:center;justify-content:center;text-align:center;white-space:normal;}',
      '  #reno-tab-widget .reno-panel{position:fixed;left:12px;right:12px;bottom:96px;top:auto;width:auto;max-width:none;margin-top:0;transform:translateY(16px);border-radius:12px;max-height:65vh;}',
      '  #reno-tab-widget.reno-open .reno-panel{transform:translateY(0) !important;}',
      '}'
    ].join('\n');
    document.head.appendChild(style);

    var extraCats = CFG.links.length ? (
      '<div class="reno-cats-label">Or browse Pick 2 by category:</div>' +
      '<div class="reno-cats">' + CFG.links.map(function(c){ return '<a href="' + c.url + '">' + c.label + '</a>'; }).join('') + '</div>'
    ) : '';

    var backdrop = document.createElement('div');
    backdrop.id = 'reno-backdrop';
    document.body.appendChild(backdrop);

    var widget = document.createElement('div');
    widget.id = 'reno-tab-widget';
    widget.innerHTML =
      '<button class="reno-tab" type="button"></button>' +
      '<div class="reno-panel">' +
        '<div class="reno-panel-head">' +
          '<div class="reno-track" style="flex:1;margin-bottom:0;"><div class="reno-fill"></div></div>' +
          '<button class="reno-close" type="button" aria-label="Close">&times;</button>' +
        '</div>' +
        '<div class="reno-text" style="margin-top:8px;"></div>' +
        '<div class="reno-picks">' +
          '<a class="reno-pick" href="' + CFG.pick1Url + '">' +
            '<span class="reno-pick-title">\uD83C\uDF81 ' + CFG.pick1Label + '</span>' +
            '<span class="reno-pick-code">' + CFG.pick1Note + '</span>' +
          '</a>' +
          '<a class="reno-pick" href="' + CFG.pick2Url + '">' +
            '<span class="reno-pick-title">\u2728 ' + CFG.pick2Label + '</span>' +
            '<span class="reno-pick-code">Use code ' + CFG.pick2Code + ' at checkout</span>' +
          '</a>' +
          extraCats +
        '</div>' +
      '</div>';
    document.body.appendChild(widget);

    widget.querySelector('.reno-tab').addEventListener('click', function(){
      var isOpen = widget.classList.toggle('reno-open');
      sessionStorage.setItem('renoTabOpen', isOpen ? '1' : '0');
      backdrop.classList.toggle('reno-visible', isOpen && window.innerWidth <= 600);
    });

    widget.querySelector('.reno-close').addEventListener('click', function(){
      closeWidget(widget);
      backdrop.classList.remove('reno-visible');
    });

    backdrop.addEventListener('click', function(){
      closeWidget(widget);
      backdrop.classList.remove('reno-visible');
    });

    document.addEventListener('keydown', function(e){
      if (e.key === 'Escape' && widget.classList.contains('reno-open')) {
        closeWidget(widget);
        backdrop.classList.remove('reno-visible');
      }
    });

    return widget;
  }

  function updateWidget(cart){
    var widget = buildWidget();
    var total = cart.total_price;
    var pct = Math.min(100, (total / CFG.thresholdCents) * 100);
    var unlocked = total >= CFG.thresholdCents;

    widget.querySelector('.reno-fill').style.width = pct + '%';
    widget.querySelector('.reno-tab').textContent = unlocked ? CFG.tabLabelUnlocked : CFG.tabLabel;

    if (unlocked) {
      widget.classList.add('reno-unlocked');
      widget.querySelector('.reno-text').textContent = CFG.unlockedText;
    } else {
      widget.classList.remove('reno-unlocked');
      var remaining = CFG.thresholdCents - total;
      widget.querySelector('.reno-text').textContent = fillTemplate(CFG.lockedText, remaining);
    }

    var shouldShow = !CFG.showOnlyWithItems || total > 0;
    widget.style.display = shouldShow ? 'flex' : 'none';

    var storedOpen = sessionStorage.getItem('renoTabOpen');
    var shouldOpen = storedOpen === '1' || (storedOpen === null && CFG.openDefault);

    if (forceOpenNext) {
      shouldOpen = true;
      sessionStorage.setItem('renoTabOpen', '1');
      widget.classList.add('reno-pulse');
      setTimeout(function(){ widget.classList.remove('reno-pulse'); }, 700);
      forceOpenNext = false;
    }

    if (shouldOpen) {
      widget.classList.add('reno-open');
      var backdropEl = document.getElementById('reno-backdrop');
      if (backdropEl) backdropEl.classList.toggle('reno-visible', window.innerWidth <= 600);
    }
  }

  function guardCollectionPage(cart){
    if (!CFG.gateEnabled) return;
    if (window.location.pathname.indexOf(CFG.gatePrefix) !== 0) return;
    if (cart.total_price >= CFG.thresholdCents) return;
    if (document.getElementById('reno-gate-overlay')) return;

    var overlay = document.createElement('div');
    overlay.id = 'reno-gate-overlay';
    overlay.style.cssText = 'position:fixed;inset:0;z-index:9999;background:' + CFG.barBg + 'f5;color:' + CFG.barText + ';display:flex;align-items:center;justify-content:center;text-align:center;padding:32px;';
    var remaining = CFG.thresholdCents - cart.total_price;
    overlay.innerHTML =
      '<div style="max-width:420px;">' +
        '<h2 style="margin:0 0 12px;font-size:22px;">Almost there!</h2>' +
        '<p style="margin:0 0 20px;line-height:1.5;">' + fillTemplate(CFG.gateText, remaining) + '</p>' +
        '<a href="' + CFG.gateButtonUrl + '" style="display:inline-block;background:' + CFG.buttonColor + ';color:' + CFG.barText + ';padding:12px 22px;border-radius:6px;text-decoration:none;font-weight:600;">' + CFG.gateButtonLabel + '</a>' +
      '</div>';
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
  }

  function refreshAll(){
    getCart(function(cart){
      updateWidget(cart);
      guardCollectionPage(cart);
    });
  }

  function markAddToCart(){
    forceOpenNext = true;
    setTimeout(refreshAll, 500);
    setTimeout(refreshAll, 1200); // second pass in case the cart API was still updating on the first
  }

  document.addEventListener('DOMContentLoaded', refreshAll);
  document.addEventListener('cart:updated', refreshAll);
  document.addEventListener('cart:refresh', refreshAll);
  document.addEventListener('cart:build', refreshAll);

  // Catches standard (non-AJAX-intercepted) add-to-cart form submissions
  document.addEventListener('submit', function(e){
    if (e.target && e.target.action && e.target.action.indexOf('/cart/add') !== -1) {
      markAddToCart();
    }
  }, true);

  // Catches AJAX/fetch-based add-to-cart calls (quick-add buttons, cart drawers using fetch instead of a form submit)
  if (window.fetch) {
    var originalFetch = window.fetch;
    window.fetch = function(){
      var urlArg = arguments[0];
      var url = typeof urlArg === 'string' ? urlArg : (urlArg && urlArg.url) || '';
      var isAdd = url.indexOf('/cart/add') !== -1;
      var result = originalFetch.apply(this, arguments);
      if (isAdd) {
        result.then(function(){ markAddToCart(); }).catch(function(){});
      }
      return result;
    };
  }

  setInterval(refreshAll, POLL_MS);
  if (document.readyState !== 'loading') { refreshAll(); }
})();
